<template>
  <v-container>
    <v-row class="pa-4 ma-0 contenedor">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <!-- <h1>{{ $STR.tituloCentroAyuda }}</h1> -->
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 nav-contenedor-primary">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <h5> <router-link :to="routeDashboard">{{ $STR.navDashboard }} </router-link> > <b>{{ $STR.navNuevaPregunta }}</b></h5>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 subtitulo-contenedor-primary">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <!-- <h2>{{ $STR.subtituloMaterialApoyo }} </h2> -->
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col  lg="12" md="12" sm="12" class="pa-0 ma-0">
        <grid
          :tabla="'BC_Preguntas'"
          :Detalles="''"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="true"
          :sIdTable="'idBC_Preguntas'"
          :bShowMapDetails="true"
          @idSelect="getIdSelect"
          @nameField="getNameFieldSelect"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import { mixFunciones } from "@/mixins/funciones.js";
import grid from '@/components/Grid/Grid.vue'

export default {
  name: "dashboard-modulo-ayuda",
  // mixins: [mixFunciones],
    components: {
    grid
  },
  mounted() {
  
  },
  data() {
    return {
      routeDashboard: '/Inicio/centro-de-ayuda/ayuda/dashboard',
      idSelect: '',                  // Id seleccionado
      nameField: '',                 // Nombre del campo foreignKey
      sToken: this.$route.params.token,
    };
  },
  methods: {
    getIdSelect(sIdSelected) {
      this.idSelect = sIdSelected;
    },
    getNameFieldSelect(sNameFiled) {
      this.nameField = sNameFiled;
    }
  },
};
</script>